type TemplatePreviewLoadingStateProps = {
  className?: string;
  context: string;
  flush?: boolean;
  label: string;
};

export function TemplatePreviewLoadingState({
  className = "",
  context,
  flush = false,
  label,
}: TemplatePreviewLoadingStateProps) {
  return (
    <div
      aria-live="polite"
      className={[
        "relative isolate min-h-72 overflow-hidden bg-bg-sunken text-text",
        flush ? "rounded-none" : "rounded-[28px]",
        className,
      ].join(" ")}
      data-template-loading-context={context}
      role="status"
    >
      <div
        aria-hidden="true"
        className="absolute inset-0 overflow-hidden"
        data-template-loading-artwork="true"
      >
        <span className="absolute -left-12 -top-14 h-44 w-44 animate-pulse rounded-full bg-primary/10 blur-[56px] motion-reduce:animate-none" />
        <span className="absolute -bottom-16 -right-10 h-52 w-52 animate-pulse rounded-full bg-primary/10 blur-[64px] motion-reduce:animate-none [animation-delay:320ms]" />

        <div className="absolute inset-4 overflow-hidden rounded-[20px] bg-surface sm:inset-5">
          <div className="flex h-9 items-center gap-1.5 bg-primary/[0.04] px-4">
            <span className="h-1.5 w-1.5 rounded-full bg-text-muted/30" />
            <span className="h-1.5 w-1.5 rounded-full bg-text-muted/20" />
            <span className="h-1.5 w-1.5 rounded-full bg-text-muted/10" />
            <span className="ml-3 h-2 w-20 rounded-full bg-text-muted/10" />
          </div>

          <div className="grid h-[calc(100%_-_2.25rem)] grid-cols-[1.05fr_.95fr] gap-4 p-4 sm:gap-6 sm:p-6">
            <div className="flex min-w-0 flex-col justify-center">
              <span className="h-2 w-16 rounded-full bg-primary/40" />
              <span className="mt-3 h-4 w-[84%] rounded-full bg-text-muted/20" />
              <span className="mt-2 h-4 w-[62%] rounded-full bg-text-muted/15" />
              <span className="mt-4 h-2 w-[72%] rounded-full bg-text-muted/10" />
              <span className="mt-1.5 h-2 w-[54%] rounded-full bg-text-muted/10" />
              <span className="mt-5 h-7 w-24 rounded-full bg-gradient-to-r from-primary/50 to-primary/70" />
            </div>

            <div className="relative min-h-0 overflow-hidden rounded-[18px] bg-gradient-to-br from-primary/15 via-primary/5 to-primary/20">
              <span className="absolute -right-8 -top-9 h-28 w-28 rounded-full bg-text-muted/15" />
              <span className="absolute bottom-[14%] left-[13%] h-[48%] w-[68%] rounded-[16px] bg-primary/20" />
              <span className="absolute bottom-[21%] left-[21%] h-[31%] w-[52%] rounded-[12px] bg-surface/70" />
            </div>
          </div>
        </div>
      </div>

      <span className="absolute bottom-7 left-8 z-10 flex items-center gap-2 text-[11px] font-semibold tracking-[0.12em] text-text-secondary sm:bottom-8 sm:left-10">
        <span
          aria-hidden="true"
          className="h-1.5 w-1.5 animate-pulse rounded-full bg-primary motion-reduce:animate-none"
        />
        {label}
      </span>
    </div>
  );
}
